import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import FormHeader from './FormHeader';
import TableComponent from './TableComponent';
import Disclaimer from './Disclaimer';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    clear: 'right'
  },
  image: {
    alignSelf: 'flex-end',
    width:'10%',
    height:'15%'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  }
});

// Create Document Component
const MyDocument = ({ layoutData }) => (
  <Document>
    <Page style={styles.body}>
      <FormHeader title={layoutData.title} desc={layoutData.desc}/>
      <TableComponent componentData={layoutData.componentData}/>
      <Disclaimer disclaimerData={layoutData.disclaimerData}/>
    </Page>
  </Document>
)

export default MyDocument
